import React from 'react';
import styled from 'styled-components';
import { Card, Button } from 'antd';
import Slider from 'react-slick';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import StyledContainer from '@design-system/styled/Container';
import { contentAboutNews } from '../content';

const { Meta } = Card;

const StyledCard = styled(Card)`
  margin: 10px;

  .ant-card-meta-title {
    font-family: ${(props) => props.theme.fontFamilyBold};
  }

  .ant-card-meta {
    text-align: left;
  }
`;

const StyledCardFooter = styled.div`
  margin-top: 30px;
  > img {
    max-width: 100%;
    height: auto;
  }
`;

const StyledButtonRow = styled.div`
  margin-top: 24px;

  @media (max-width: 991px) {
    padding-top: 10px;
  }
`;

const StyledInTheNewsContainer = styled.div`
  padding: 60px 16px 40px;
  background-color: #f5f5f5;
  overflow: hidden;
  text-align: center;
  @media (max-width: 991px) {
    margin-top: 15px;
  }

  .link-read-more {
    ${(props) => props.theme.typo.familyGoogle.regular}
    padding: 16px 24px;
    text-transform: uppercase;
  }
`;
const StyledTitle = styled.h2`
  color: ${(props) => props.theme.color.onSurface};
  margin-bottom: 20px;
  font-size: 2rem;
  ${(props) => props.theme.typo.familyGoogle.bold}
`;

const StyledSubtitle = styled.p`
  color: ${(props) => props.theme.color.lightGrey};
  margin-bottom: 40px;
  font-size: 1.25rem;
  ${(props) => props.theme.typo.familyGoogle.regular}
`;

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
  ],
};

const AboutInTheNews = () => {
  const { t } = useTranslation('aboutUs');
  const renderItems = contentAboutNews.map((item, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <div key={index}>
      <a href={item.url} target="_blank" rel="noreferrer">
        <StyledCard hoverable cover={<img alt={item.alt} src={item.image} />} style={{ minHeight: 470 }}>
          <Meta title={item.title} description={item.desc} />
          <StyledCardFooter>
            <img src={item.logo} alt={`${item.title} logo`} />
          </StyledCardFooter>
        </StyledCard>
      </a>
    </div>
  ));

  return (
    <StyledInTheNewsContainer>
      <StyledContainer>
        <StyledTitle>{t('aboutUs.inTheNews')}</StyledTitle>
        <StyledSubtitle>{t('aboutUs.talkingAboutUs')}</StyledSubtitle>
        <Slider {...settings}>{renderItems}</Slider>
        <StyledButtonRow>
          <Link passHref href="https://carro.sg/blog/category/carro-news/" prefetch={false} legacyBehavior>
            <Button className="link-read-more" size="large">
              {t('aboutUs.readMoreStories')}
            </Button>
          </Link>
        </StyledButtonRow>
      </StyledContainer>
    </StyledInTheNewsContainer>
  );
};

export default AboutInTheNews;
